import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PerfilPageComponent} from './components/perfil-page.component';
import {PerfilRoutingModule} from './perfil-routing.module';
import {PrimeNgModule} from '../../shared/prime-ng/prime-ng.module';
import {SharedModule} from '../../shared/shared.module';
import { UsuarioDialogComponent } from "../mnto-usuarios/components/usuarios/usuario-dialog/usuario-dialog.component";
import { EditarPerfilComponent } from '../mnto-usuarios/components/usuarios/editar-perfil/editar-perfil.component';

@NgModule({
    declarations: [
        PerfilPageComponent
    ],
    imports: [
    CommonModule,
    PerfilRoutingModule,
    PrimeNgModule,
    SharedModule,
    UsuarioDialogComponent,
    EditarPerfilComponent
]
})
export class PerfilModule {
}
